export type SpecialEventsSectionVisibilityInput = {
	showSpecialEvents: boolean;
	errorEvents: boolean;
	loadingEvents: boolean;
	visibleEventsCount: number;
};

export type SpecialEventsSectionVisibility = {
	/** Whether the "Special Events" section (skeleton or body) should render at all. */
	showSection: boolean;
	/** Whether the skeleton placeholder should render while events are loading. */
	showSkeleton: boolean;
	/** Whether the section body (heading + carousel) should render. */
	showBody: boolean;
};

export function getSpecialEventsSectionVisibility({
	showSpecialEvents,
	errorEvents,
	loadingEvents,
	visibleEventsCount
}: SpecialEventsSectionVisibilityInput): SpecialEventsSectionVisibility {
	const showSection = showSpecialEvents && !errorEvents && (loadingEvents || visibleEventsCount > 0);
	const showSkeleton = showSection && loadingEvents;
	const showBody = showSection && !loadingEvents && visibleEventsCount > 0;

	return { showSection, showSkeleton, showBody };
}
